import React, { Component } from "react";
import { Image, Alert } from "react-bootstrap";

import SealIcon from "./../../../assets/images/alert/SealCheck.svg";
import HourIcon from "./../../../assets/images/alert/Hourglass.svg";
import CrossIcon from "./../../../assets/images/alert/XCircle.svg";

class Alerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      variant: props.variant || "success", // Default variant is 'success'
      content: props.content || "Default content", // Default content if no content is passed
      className: props.className || "Default class", // Default content if no content is passed
      iconSrc: props.content,
    };
  }

  render() {
    const { variant, content, className, iconSrc } = this.state;

    // Conditional rendering based on the variant
    if (variant === "success") {
      return (
        <Alert
          className={`custom-alert ${className}`}
          key={variant}
          variant={variant}
        >
          <Image src={SealIcon || iconSrc} /> {content}
        </Alert>
      );
    }

    if (variant === "warning") {
      return (
        <Alert
          className={`custom-alert ${className}`}
          key={variant}
          variant={variant}
        >
          <Image src={HourIcon || iconSrc} /> {content}
        </Alert>
      );
    }

    // Add more variants if needed
    if (variant === "danger") {
      return (
        <Alert
          className={`custom-alert ${className}`}
          key={variant}
          variant={variant}
        >
          <Image src={CrossIcon || iconSrc} /> {content}
        </Alert>
      );
    }

    return null; // Return nothing if the variant doesn't match any cases
  }
}

export default Alerts;
